import { render, staticRenderFns } from "./ResourcePreview.vue?vue&type=template&id=62a645b7&scoped=true"
import script from "./ResourcePreview.vue?vue&type=script&lang=js"
export * from "./ResourcePreview.vue?vue&type=script&lang=js"
import style0 from "./ResourcePreview.vue?vue&type=style&index=0&id=62a645b7&prod&scoped=true&lang=css"
import style1 from "./ResourcePreview.vue?vue&type=style&index=1&id=62a645b7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a645b7",
  null
  
)

export default component.exports